import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getVendingMachine, updateVendingMachine, getVendingMachinesStock } from '../../actions/vendingMachine';
import { getProfiles } from '../../actions/profile';
import { 
    ArrowLeft, 
    Package, 
    Monitor, 
    MapPin, 
    Settings, 
    Wifi, 
    WifiOff, 
    QrCode,
    Edit3,
    Save,
    User,
    BarChart3,
    Box,
    AlertTriangle,
    CheckCircle,
    Clock,
    Database,
    Activity
} from 'lucide-react';

const initialState = {
    name: '',
    vendingMachineId: '',
    location: '',
    active:'',
    qrCode:'',
    live:false,
    profileName:'',
    profile: '',
    region: '',
    referenceId: '',
    // Address fields - updated structure
    addressNumber: '',
    addressName: '',
    addressLine: '',
    city: '',
    state: '',
    country: '',
    pincode: ''
};

let inventoryState = {"available": 0, "reserved": 0, "empty" : 0, "failures" : 0, "unassigned": 0};
let brandStockState = {};

const VendingMachineDetails = ({
    vendingMachine : { vendingMachine, loading },
    getVendingMachine,
    updateVendingMachine,
    getVendingMachinesStock,
    stockInfo,
    profiles,
    getProfiles
}) => {
    const { id } = useParams();
    const [formData, setFormData] = useState(initialState);
    const [inventoryDetails, setInventoryData] = useState(inventoryState);
    const [brandStockDetails, setStockData] = useState(brandStockState);
    const [redisBrandStockDetails, setRedisStockData] = useState({available:{}, containers:[], reserved:{}});
    const [lastUpdatedOn, setUpdatedOn] = useState(0);
    const [profileData, setProfileData] = useState({profile:"", profileId:""});
    const [isEditing, setIsEditing] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        if (!vendingMachine ){
            getVendingMachine(id);
            getVendingMachinesStock(id);
            getProfiles();
        } else if( vendingMachine._id !== id){
            getVendingMachine(id);
            getVendingMachinesStock(id);
            getProfiles();
        }

        if(vendingMachine){
            setProfileData({ profile : vendingMachine.profileName, profileId : vendingMachine.profile})
        }

        if ("brandStock" in stockInfo) {
            const inventoryData = { ...inventoryState };
            const brandStockData = { ...brandStockState};
            Object.keys(stockInfo.brandStock).forEach(brand => {
                brandStockData[brand] = stockInfo.brandStock[brand];
            });
            inventoryData["failures"] += stockInfo.containersInfo.failure;
            inventoryData["reserved"] += stockInfo.containersInfo.reserved;
            inventoryData["empty"] += stockInfo.containersInfo.empty;
            inventoryData["available"] += stockInfo.containersInfo.available;
            inventoryData["unassigned"] += stockInfo.containersInfo.unassigned;
            setInventoryData(inventoryData);
            setStockData(brandStockData);
            setRedisStockData(stockInfo.redisStock);
        }

        if("liveStatus" in stockInfo){
            if(stockInfo.liveStatus){
                setUpdatedOn(stockInfo.liveStatus.lastUpdatedOn);
            }
        }

        if(vendingMachine && vendingMachine._id === id){
            const vendingMachineData = { ...initialState };
            for (const key in vendingMachine) {
                if (key in vendingMachineData) vendingMachineData[key] = vendingMachine[key];
            }
            // Handle address object - updated structure
            if (vendingMachine.address) {
                vendingMachineData.addressNumber = vendingMachine.address.number || '';
                vendingMachineData.addressName = vendingMachine.address.name || '';
                vendingMachineData.addressLine = vendingMachine.address.addressLine || '';
                vendingMachineData.city = vendingMachine.address.city || '';
                vendingMachineData.state = vendingMachine.address.state || '';
                vendingMachineData.country = vendingMachine.address.country || '';
                vendingMachineData.pincode = vendingMachine.address.pincode || '';
            }
            setFormData(vendingMachineData);
        }
    }, [loading, getVendingMachine, vendingMachine, id, getVendingMachinesStock, stockInfo, profiles]);

    const populateAllStock = () => {
        return (
            Object.keys(brandStockDetails).map((value, index) => {
                return (
                    <tr key={value} className="text-center">
                        <td className="fw-bold text-primary">{value}</td>
                        <td>
                            <span className={`badge ${brandStockDetails[value] > 0 ? 'bg-success' : 'bg-danger'} fs-6`}>
                                {brandStockDetails[value]}
                            </span>
                        </td>
                </tr>
                )
            })
        )
    }

    const populateRedisAvailableStock = () => {
        return (
            Object.keys(redisBrandStockDetails.available).map((value, index) => {
                return (
                    <tr key={value} className="text-center">
                        <td className="fw-bold text-info">{value}</td>
                        <td>
                            <span className={`badge ${redisBrandStockDetails.available[value] > 0 ? 'bg-success' : 'bg-warning'} fs-6`}>
                                {redisBrandStockDetails.available[value]}
                            </span>
                        </td>
                </tr>
                )
            })
        );
    }

    const populateRedisReservedStock = () =>{
        return (
            Object.keys(redisBrandStockDetails.reserved).map((key, index) => {
                return (
                    <tr key={key} className="text-center">
                        <td className="fw-bold text-warning">{redisBrandStockDetails.reserved[key].productId}</td>
                        <td className="text-muted">{redisBrandStockDetails.reserved[key].brand}</td>
                        <td className="small text-muted">
                            <Clock size={14} className="me-1" />
                            {Math.floor((Date.parse(new Date()) - redisBrandStockDetails.reserved[key].time)/1000)} sec ago
                    </td>
                </tr>
                )
            })
        );
    }
    
    const {
        name,
        vendingMachineId,
        location,
        active,
        qrCode,
        profileName,
        profile,
        region,
        referenceId,
        addressNumber,
        addressName,
        addressLine,
        city,
        state,
        country,
        pincode
    } = formData;

    const onChange = e =>
        setFormData({ ...formData, [e.target.name]: e.target.value });
  
    const onSubmit = async e => {
      e.preventDefault();
        setIsUpdating(true);
        try {
            // Prepare data with address object - updated structure
            const updateData = {
                ...formData,
                address: {
                    number: formData.addressNumber,
                    name: formData.addressName,
                    addressLine: formData.addressLine,
                    city: formData.city,
                    state: formData.state,
                    country: formData.country,
                    pincode: formData.pincode
                }
            };
            await updateVendingMachine(vendingMachine._id, updateData);
            setIsEditing(false);
        } finally {
            setIsUpdating(false);
        }
    };

    const onProfileDataChange = e => {
        let newProfileData = { profile : e.target[e.target.selectedIndex].text, profileId : e.target.value }
        setProfileData(newProfileData);
    }

    const showProfiles = () => {
        return profiles.map((profile, index) => {
            return (
                <option key={`profile-${index}`} value={profile._id}>{profile.name}</option>
            )
        });
    }

    let renderLiveStatus = (lastUpdatedOn) => {
        if(!lastUpdatedOn){
            return (
                <span className="badge bg-danger fs-6 d-flex align-items-center w-fit">
                    <WifiOff size={14} className="me-1" />
                    Offline
                </span>
            );
        }else{
            let currenDatetime = new Date();
            let timeDelta = (Date.parse(currenDatetime) - lastUpdatedOn)/1000;
            if(timeDelta <= `${ Number(process.env.REACT_APP_VENDING_MACHINE_EXPIRE_TIME)}`) {
                return (
                    <span className="badge bg-success fs-6 d-flex align-items-center w-fit">
                        <Wifi size={14} className="me-1" />
                        Online
                    </span>
                );
            }
            return (
                <span className="badge bg-danger fs-6 d-flex align-items-center w-fit">
                    <WifiOff size={14} className="me-1" />
                    Offline
                </span>
            );
        }
    }

    const updateProfile = async () => {
        setIsUpdating(true);
        try {
            await updateVendingMachine(vendingMachine._id, {profile: profileData.profileId, profileName: profileData.profile});
        } finally {
            setIsUpdating(false);
        }
    }

    const getContainerStatusIcon = (type) => {
        switch(type) {
            case 'available': return <CheckCircle size={16} className="text-success me-2" />;
            case 'reserved': return <Clock size={16} className="text-warning me-2" />;
            case 'empty': return <Box size={16} className="text-secondary me-2" />;
            case 'failures': return <AlertTriangle size={16} className="text-danger me-2" />;
            case 'unassigned': return <Package size={16} className="text-info me-2" />;
            default: return <Box size={16} className="text-muted me-2" />;
        }
    }

    const getContainerStatusColor = (type) => {
        switch(type) {
            case 'available': return 'success';
            case 'reserved': return 'warning';
            case 'empty': return 'secondary';
            case 'failures': return 'danger';
            case 'unassigned': return 'info';
            default: return 'secondary';
        }
    }

    return (
    <Fragment>
            <div className="container-fluid py-4">
                {/* Header Section */}
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div>
                                <Link className="btn btn-outline-primary d-flex align-items-center mb-2" to="/">
                                    <ArrowLeft size={16} className="me-2" />
                                    Back to Dashboard
                </Link>
                                <h1 className="h3 mb-2 text-gray-800 fw-bold d-flex align-items-center">
                                    <Monitor size={32} className="me-3 text-primary" />
                                    {vendingMachine?.name || 'Loading...'}
                                </h1>
                                <p className="text-muted mb-0">
                                    Machine ID: <span className="fw-bold text-info">{vendingMachine?.vendingMachineId}</span>
                                </p>
                            </div>
                            <div className="d-flex gap-2 flex-wrap">
                <Link 
                                    to={`/inventory/v1.2/vendingMachine/${vendingMachine?._id || "-"}/Inventory`}
                                    className="btn btn-success btn-lg shadow-sm d-flex align-items-center"
                                >
                                    <Package size={20} className="me-2" />
                        Manage Inventory
                </Link>
            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {/* Left Column - Machine Details */}
                    <div className="col-lg-6 mb-4">
                        {/* QR Code Card */}
                        {qrCode && (
                            <div className="card shadow-sm mb-4">
                                <div className="card-header bg-primary text-white">
                                    <h5 className="mb-0 d-flex align-items-center">
                                        <QrCode size={20} className="me-2" />
                                        QR Code
                                    </h5>
                        </div>
                                <div className="card-body text-center">
                                    <img 
                                        style={{width: "200px", borderRadius: "8px"}} 
                                        alt="QR Code" 
                                        src={`${process.env.REACT_APP_SERVER_PUBLIC_PATH}${process.env.REACT_APP_IMAGE_PATH_QRCODE}/${qrCode}`}
                                        className="shadow-sm"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Machine Details Card */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                <h5 className="mb-0 d-flex align-items-center">
                                    <Settings size={20} className="me-2" />
                                    Machine Details
                                </h5>
                                <button 
                                    className="btn btn-sm btn-light text-info"
                                    onClick={() => setIsEditing(!isEditing)}
                                >
                                    <Edit3 size={14} className="me-1" />
                                    {isEditing ? 'Cancel' : 'Edit'}
                                </button>
                            </div>
                            <div className="card-body">
                                <form onSubmit={onSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <Monitor size={16} className="me-2 text-primary" />
                                                Machine Name
                                            </label>
                                <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Vending Machine Name"
                                                name="name"
                                                value={name}
                                                onChange={onChange}
                                    required
                                                disabled={!isEditing}
                                />
                            </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <Settings size={16} className="me-2 text-info" />
                                                Machine ID
                                            </label>
                                <input
                                                className="form-control"
                                                type="text"
                                                name="vendingMachineId"
                                                value={vendingMachineId}
                                                readOnly
                                                style={{backgroundColor: '#f8f9fa'}}
                                />
                            </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <Settings size={16} className="me-2 text-secondary" />
                                                Reference ID
                                            </label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="referenceId"
                                                value={referenceId}
                                                readOnly
                                                style={{backgroundColor: '#f8f9fa'}}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <User size={16} className="me-2 text-secondary" />
                                                Product Profile
                                            </label>
                                            <select
                                                className="form-select"
                                                name="profile"
                                                value={profile}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            >
                                                <option value="">Select Profile</option>
                                                {profiles && profiles.map((prof, index) => (
                                                    <option key={`profile-${index}`} value={prof._id}>
                                                        {prof.name}
                                                    </option>
                                                ))}
                                            </select>
                            </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <Activity size={16} className="me-2 text-warning" />
                                                Status
                                            </label>
                                <select
                                                className="form-select"
                                value={active}
                                                name="active"
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            >
                                    <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                </select>
                            </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <MapPin size={16} className="me-2 text-success" />
                                                Region
                                            </label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Region"
                                                name="region"
                                                value={region}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                <Wifi size={16} className="me-2" />
                                                Live Status
                                            </label>
                                            <div className="mt-2">
                                                {renderLiveStatus(lastUpdatedOn)}
                                            </div>
                                        </div>
                                        
                                        {/* Address Section */}
                                        <div className="col-12">
                                            <hr className="my-3" />
                                            <h6 className="text-muted fw-bold mb-3">
                                                <MapPin size={16} className="me-2" />
                                                Address Details
                                            </h6>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Building Number</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="e.g., #201, Block A"
                                                name="addressNumber"
                                                value={addressNumber}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Building Name</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="e.g., New Tower"
                                                name="addressName"
                                                value={addressName}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-bold">Address Line</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="e.g., 1st Main 2nd Cross"
                                                name="addressLine"
                                                value={addressLine}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-bold">City</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="City"
                                                name="city"
                                                value={city}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-bold">State</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="State"
                                                name="state"
                                                value={state}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-bold">Country</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Country"
                                                name="country"
                                                value={country}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Pincode</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="123456"
                                                name="pincode"
                                                value={pincode}
                                                onChange={onChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Full Address Preview</label>
                                            <div className="form-control bg-light" style={{minHeight: '38px', display: 'flex', alignItems: 'center'}}>
                                                <small className="text-muted">
                                                    {[addressNumber, addressName, addressLine, city, state, country, pincode]
                                                        .filter(Boolean)
                                                        .join(', ') || 'Address will appear here...'}
                                                </small>
                                            </div>
                                        </div>
                                        
                                        {/* Location Coordinates */}
                                        {vendingMachine?.location?.coordinates && (
                                            <div className="col-12">
                                                <hr className="my-3" />
                                                <h6 className="text-muted fw-bold mb-3">
                                                    <MapPin size={16} className="me-2" />
                                                    Location Coordinates
                                                </h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label fw-bold">Latitude</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={vendingMachine.location.coordinates[0] || ''}
                                                            readOnly
                                                            style={{backgroundColor: '#f8f9fa'}}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label fw-bold">Longitude</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={vendingMachine.location.coordinates[1] || ''}
                                                            readOnly
                                                            style={{backgroundColor: '#f8f9fa'}}
                                                        />
                                                    </div>
                                                </div>
                                </div>
                                        )}
                                    </div>
                                    {isEditing && (
                                        <div className="mt-4 text-center">
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary btn-lg d-flex align-items-center mx-auto"
                                                disabled={isUpdating}
                                            >
                                                {isUpdating ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                        Updating...
                                                    </>
                                                ) : (
                                                    <>
                                                        <Save size={16} className="me-2" />
                                                        Update Machine
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </form>
                                </div>
                        </div>
                    </div>

                    {/* Right Column - Stock Information */}
                    <div className="col-lg-6">
                        {/* Brand Stock Card */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-success text-white">
                                <h5 className="mb-0 d-flex align-items-center">
                                    <BarChart3 size={20} className="me-2" />
                                    Brand Stock Overview
                                </h5>
                            </div>
                            <div className="card-body">
                                {Object.keys(brandStockDetails).length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center">Brand</th>
                                                    <th className="text-center">Stock Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                                {populateAllStock()}
                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-4">
                                        <Package size={48} className="text-muted mb-3" />
                                        <p className="text-muted">No stock data available</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Container Status Card */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-secondary text-white">
                                <h5 className="mb-0 d-flex align-items-center">
                                    <Box size={20} className="me-2" />
                                    Container Status
                                </h5>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                    {Object.entries(inventoryDetails).map(([type, count]) => (
                                        <div key={type} className="col-md-6">
                                            <div className={`card border-${getContainerStatusColor(type)} h-100`}>
                                                <div className="card-body text-center">
                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                        {getContainerStatusIcon(type)}
                                                        <span className="text-capitalize fw-bold">{type}</span>
                                                    </div>
                                                    <h3 className={`text-${getContainerStatusColor(type)} mb-0`}>
                                                        {count}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Redis Stock Info Card */}
                        <div className="card shadow-sm">
                            <div className="card-header bg-dark text-white">
                                <h5 className="mb-0 d-flex align-items-center">
                                    <Database size={20} className="me-2" />
                                    Redis Stock Information
                                </h5>
                            </div>
                            <div className="card-body">
                                {/* Available Stock */}
                                <div className="mb-4">
                                    <h6 className="text-success fw-bold mb-3">
                                        <CheckCircle size={16} className="me-2" />
                                        Available Stock
                                    </h6>
                                    {Object.keys(redisBrandStockDetails.available).length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-sm table-hover">
                                                <thead className="table-success">
                                                    <tr>
                                                        <th className="text-center">Brand</th>
                                                        <th className="text-center">Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                                    {populateRedisAvailableStock()}
                            </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="alert alert-info">
                                            <CheckCircle size={16} className="me-2" />
                                            No available stock data
                                        </div>
                                    )}
                                </div>

                                {/* Reserved Stock */}
                            <div>
                                    <h6 className="text-warning fw-bold mb-3">
                                        <Clock size={16} className="me-2" />
                                        Reserved Stock
                                    </h6>
                                    {Object.keys(redisBrandStockDetails.reserved).length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-sm table-hover">
                                                <thead className="table-warning">
                                                    <tr>
                                                        <th className="text-center">Container</th>
                                                        <th className="text-center">Brand</th>
                                                        <th className="text-center">Reserved Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                                    {populateRedisReservedStock()}
                                    </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="alert alert-success">
                                            <CheckCircle size={16} className="me-2" />
                                            No reserved containers
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </Fragment>
  );
};

VendingMachineDetails.propTypes = {
    vendingMachine: PropTypes.object.isRequired,
    stockInfo: PropTypes.object.isRequired,
    getVendingMachine: PropTypes.func.isRequired,
    updateVendingMachine: PropTypes.func.isRequired,
    getVendingMachinesStock: PropTypes.func.isRequired,
    getProfiles:PropTypes.func.isRequired,
    profiles: PropTypes.array
};

const mapStateToProps = state => ({
    stockInfo: state.vendingMachine.stockInfo,
    vendingMachine: state.vendingMachine,
    profiles: state.profile.profiles
});

export default connect(
    mapStateToProps, 
    { getVendingMachinesStock,getVendingMachine,updateVendingMachine, getProfiles }
)(VendingMachineDetails);